export default __webpack_public_path__ + "static/media/free_bag1.3d558fa7.png";